module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout-ucenter', [_c('template', {
    slot: "menu"
  }, [(_vm.user.type == 2 || _vm.user.type == 3) ? _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "router": true,
      "default-active": "1"
    }
  }, [_c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-share"
  }), _vm._v(" 内容管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/share/my-content"
    }
  }, [_vm._v("我的内容")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/share/platform-content"
    }
  }, [_vm._v("平台内容")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticClass: "d-b c-i",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "javascript:void(0)",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.newContent.open()
      }
    }
  }, [_vm._v("制作内容")])]), _vm._v(" "), (_vm.user.type == 3) ? _c('el-menu-item', {
    attrs: {
      "index": "/share/product"
    }
  }, [_vm._v("推荐内容")]) : _vm._e()], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-kkt-wechat"
  }), _vm._v(" 公众号管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/weixin/authorize"
    }
  }, [_vm._v("授权管理")]), _vm._v(" "), (_vm.user.type == 3) ? _c('el-menu-item', {
    attrs: {
      "index": "/weixin/authorize-history"
    }
  }, [_vm._v("授权记录")]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/weixin/menus"
    }
  }, [_vm._v("菜单管理")])], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" 运营管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/share/category-list"
    }
  }, [_vm._v("内容分类管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/share/banner"
    }
  }, [_vm._v("Banner管理")])], 2)], 1) : _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "router": true,
      "default-active": "1"
    }
  }, [_c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-share"
  }), _vm._v(" 内容管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/share/my-content"
    }
  }, [_vm._v("我的内容")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/share/platform-content"
    }
  }, [_vm._v("平台内容")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticClass: "d-b c-i",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "javascript:void(0)",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.newContent.open()
      }
    }
  }, [_vm._v("制作内容")])])], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-kkt-wechat"
  }), _vm._v(" 公众号管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/weixin/authorize"
    }
  }, [_vm._v("授权管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/weixin/menus"
    }
  }, [_vm._v("菜单管理")])], 2)], 1), _vm._v(" "), _c('new-content-dialog', {
    ref: "newContent"
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-d427b73a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/share-container.vue
// module id = 223
// module chunks = 29